import { render } from "./ClassTaskSubmit.vue?vue&type=template&id=4bf375d6&scoped=true"
import script from "./ClassTaskSubmit.vue?vue&type=script&lang=js"
export * from "./ClassTaskSubmit.vue?vue&type=script&lang=js"

import "./ClassTaskSubmit.vue?vue&type=style&index=0&id=4bf375d6&scoped=true&lang=css"

import exportComponent from "/Users/shenshenmac/codes/fan_mei/fanmei_v3/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bf375d6"]])

export default __exports__